export default "__VITE_ASSET__Ci2b4_l1__"